import React, {useEffect, useContext, Fragment, useMemo} from 'react';
import { observer } from "mobx-react";
import _ from 'lodash'
import {Context} from '../../store/context';
import PhotoRoutes from './PhotoRoutes/PhotoRoutes';
import PathFinderControls from './PathFinderControls/PathFinderControls';
import './PathFinder.css'
import {IQueryParams} from '../../types/IQueryParams';
import {getTranslate} from '../../utils/translate';
import {ILanguage} from '../../types/ILanguage';
import Splash from '../ui/Splash/index';
import {QueryParams} from '../../types/QueryParams';


const PathFinder = observer(() => {
    const {buildingsStore, queryParamsStore, pathFinderStore, defaultDestinationsStore, nodesStore, languagesStore, uiContentsStore, linksStore} = useContext(Context);
    const {queryParams, setQueryParam} = queryParamsStore;
    const {building, multiBuildings} = buildingsStore;
    const {pathFinder, getPathFinder} = pathFinderStore;
    const {defaultDestinations} = defaultDestinationsStore;
    const {languages} = languagesStore;
    const {uiContents} = uiContentsStore;
    const {link, setLink} = linksStore;

    const routeLang: string | undefined = queryParams?.routeLang;

    const shouldFetchRoute = useMemo(() => {
        if (!building) return false;
        const blangs = buildingsStore.buildingAvailableLanguages;
        return !queryParams.routeLang || blangs.includes(queryParams.routeLang);
    }, [building, queryParams.routeLang]);

    useEffect(() => {
        queryParams && shouldFetchRoute && getPathFinder(queryParams);
    }, [JSON.stringify(queryParams)]);

    useEffect(() => {
        document.dir = languagesStore.currentLanguage?.rtl ? 'rtl' : 'auto';
    }, [languagesStore.currentIETF])


    const buildingLangs: ILanguage[] | undefined = useMemo(() => {
        if(building && languages) {
            const blangs = buildingsStore.buildingAvailableLanguages;
            return languages.filter(language => {
                return blangs.some(blang => blang === language.ietf);
            })
        }
        return [] as ILanguage[]
    }, [building, languages]);

    const translateText = useMemo(() => {
        if(uiContents && routeLang) {
            return getTranslate(uiContents, routeLang);
        }
    }, [uiContents, routeLang]);

    const setQueryParamItem = (key: keyof IQueryParams, value: string) => {
        if(queryParams) {
            const newParams: IQueryParams = {...queryParams};
            newParams[key] = value;
            setQueryParam(newParams);
        }
    };


    const onBuildingParamsChanged = (queryBuildingId: string) => {
        if(!queryParams) return;
        const newParams: IQueryParams = _.omit(queryParams, [QueryParams.nodeFrom, QueryParams.nodeTo]);
        newParams.buildingId = queryBuildingId;
        setQueryParam(newParams);
    };

    if (!queryParams || !buildingLangs || !translateText) return <Splash/>;

    return (
        <Fragment>
            <PathFinderControls
                building = {building}
                queryParams = {queryParams}
                buildingLangs = {buildingLangs}
                translateText = {translateText}
                multiBuildings = {multiBuildings}
                setQueryParamItem = {setQueryParamItem}
                onBuildingParamsChanged = {onBuildingParamsChanged}
                link = {link?.href}
            />
            <PhotoRoutes
                loading = {pathFinderStore.loading}
                pathFinder = {pathFinder}
                translateText = {translateText}
                queryParams = {queryParams}
            />
        </Fragment>
    )
});

export default PathFinder;
